import { useEffect } from 'react';

const SITE_NAME = 'Nannies to the Rescue';

/**
 * Sets the document <title> for a page and restores the bare site name on
 * unmount, so every route has a real title in the tab, in history and in
 * search results — not just the site name on its own.
 */
export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
    return () => { document.title = SITE_NAME; };
  }, [title]);
}
